(function index(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.FullImageViewerMain) {
    return;
  }

  global.NewHomeSource.FullImageViewerMain();
}(window));
